import { Link, useLocation } from 'react-router-dom';
import { useState, useEffect } from 'react';

const navItems = [
  { label: '首页', path: '/' },
  { label: '分类浏览', path: '/category/remen-tuijian' },
  { label: '下载安装', path: '/article/aiye-video-app-xiazai-anjiao' },
  { label: '使用技巧', path: '/article/aiye-video-app-shiyong-jiqiao' },
  { label: '关于我们', path: '/about' },
];

export default function Navbar() {
  const location = useLocation();
  const [scrolled, setScrolled] = useState(false);
  const [mobileMenuOpen, setMobileMenuOpen] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      setScrolled(window.scrollY > 20);
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  useEffect(() => {
    setMobileMenuOpen(false);
  }, [location.pathname]);

  const isActive = (path: string) => {
    if (path === '/') return location.pathname === '/';
    return location.pathname.startsWith(path);
  };

  return (
    <nav
      className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${
        scrolled
          ? 'bg-background-50/95 backdrop-blur-md shadow-sm'
          : 'bg-transparent'
      }`}
    >
      <div className="w-full px-4 md:px-6">
        <div className="flex items-center justify-between h-16">
          <Link
            to="/"
            className="flex items-center gap-2 text-foreground-950 font-heading font-bold text-xl whitespace-nowrap cursor-pointer"
          >
            <span className="w-8 h-8 flex items-center justify-center bg-primary-500 text-background-50 rounded-lg">
              <i className="ri-play-circle-fill text-lg"></i>
            </span>
            爱液视频
          </Link>

          <div className="hidden md:flex items-center gap-1">
            {navItems.map((item) => (
              <Link
                key={item.path}
                to={item.path}
                className={`px-4 py-2 rounded-md text-sm font-medium transition-colors duration-200 whitespace-nowrap cursor-pointer ${
                  isActive(item.path)
                    ? 'bg-primary-50 text-primary-700'
                    : 'text-foreground-600 hover:text-foreground-900 hover:bg-background-100'
                }`}
              >
                {item.label}
              </Link>
            ))}
          </div>

          <div className="hidden md:flex items-center gap-3">
            <Link
              to="/article/aiye-video-app-xiazai-anjiao"
              className="px-5 py-2 bg-primary-500 text-background-50 rounded-full text-sm font-medium hover:bg-primary-600 transition-colors duration-200 whitespace-nowrap cursor-pointer"
            >
              <i className="ri-download-line mr-1"></i>
              立即下载
            </Link>
          </div>

          <button
            className="md:hidden w-10 h-10 flex items-center justify-center text-foreground-700 cursor-pointer"
            onClick={() => setMobileMenuOpen(!mobileMenuOpen)}
            aria-label="菜单"
          >
            <i className={`text-xl ${mobileMenuOpen ? 'ri-close-line' : 'ri-menu-line'}`}></i>
          </button>
        </div>
      </div>

      {mobileMenuOpen && (
        <div className="md:hidden bg-background-50 border-t border-background-200">
          <div className="px-4 py-3 flex flex-col gap-1">
            {navItems.map((item) => (
              <Link
                key={item.path}
                to={item.path}
                className={`px-4 py-3 rounded-lg text-sm font-medium transition-colors duration-200 cursor-pointer ${
                  isActive(item.path)
                    ? 'bg-primary-50 text-primary-700'
                    : 'text-foreground-600 hover:bg-background-100'
                }`}
              >
                {item.label}
              </Link>
            ))}
            <Link
              to="/article/aiye-video-app-xiazai-anjiao"
              className="mt-2 px-4 py-3 bg-primary-500 text-background-50 rounded-full text-sm font-medium text-center whitespace-nowrap cursor-pointer"
            >
              <i className="ri-download-line mr-1"></i>
              立即下载
            </Link>
          </div>
        </div>
      )}
    </nav>
  );
}